<template>
  <div class="achievement">
    <CommonLayout>
      <div slot="header">
        <h3>科技成果</h3>
      </div>
      <div slot="container">
        <div class="achievement-search">
          <el-button
              icon="el-icon-plus"
              style="background: #623aa2; border: none"
              type="success"
              @click="addAch"
          >新增
          </el-button
          >
          <el-button icon="el-icon-delete" type="danger" @click="deleteAll"
          >批量删除
          </el-button
          >
          <el-popover v-model="visible" placement="bottom" width="300">
            <el-date-picker
                v-model="times"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-dd"
            ></el-date-picker>
            <div style="text-align: right; margin-top: 10px">
              <el-button
                  size="mini"
                  type="text"
                  @click="
                  () => {
                    visible = false;
                    times = null;
                  }
                "
              >取消
              </el-button
              >
              <el-button size="mini" type="primary" @click="exportOut"
              >确定
              </el-button
              >
            </div>
            <el-button
                slot="reference"
                class="exportOut"
                icon="el-icon-download"
                style="margin-left: 10px"
                type="primary"
            >导出
            </el-button
            >
          </el-popover>
          <el-input
              v-model="searchValue"
              class="input-with-select"
              clearable
              placeholder="请输入标题内容"
              style="width: 240px"
              @clear="search"
              @keyup.enter.native="search"
          >
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
            ></el-button>
          </el-input>
          <label>行业分类:</label>
          <el-select
              v-model="fieldValue"
              clearable
              placeholder="全部"
              style="width: 140px"
              @change="search"
          >
            <el-option
                v-for="item in checkList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
          <label>技术状态:</label>
          <el-select
              v-model="jishuValue"
              clearable
              placeholder="全部"
              style="width: 140px"
              @change="search"
          >
            <el-option
                v-for="item in options.stage"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
          <label>技术先进度:</label>
          <el-select
              v-model="progressValue"
              clearable
              placeholder="全部"
              style="width: 140px"
              @change="search"
          >
            <el-option
                v-for="(item, index) in options.stage1"
                :key="index"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <div class="achievement-table">
          <el-table
              ref="multipleTable"
              :data="tableData"
              :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
              class="table"
              style="width: 100%"
              @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column
                align="center"
                label="序号"
                type="index"
                width="150"
            >
              <template slot-scope="scope">
                <span>{{
                    scope.$index + (current_page - 1) * per_page + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="成果名称"
                prop="name"
            ></el-table-column>
            <el-table-column align="center" label="成果简介">
              <template slot-scope="scope">
                <span style="display: block; height: 23px; overflow: hidden">{{
                    GetTarg(scope.row.content)
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="申请时间"
                prop="publishDateTime"
            ></el-table-column>
            <el-table-column
                align="center"
                label="审核状态"
                prop="examineStatus"
            >
              <template slot-scope="scope">
                <el-tag v-show="scope.row.examineStatus === 1" type="success"
                >通过
                </el-tag
                >
                <el-tag v-show="scope.row.examineStatus === 2" type="info"
                >未通过
                </el-tag
                >
                <el-tag v-show="scope.row.examineStatus === 3" type="danger"
                >待审核
                </el-tag
                >
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="240">
              <template slot-scope="scope">
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.$index, scope.row)"
                >编辑
                </el-button
                >
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            :current-page.sync="current_page"
            :page-size="per_page"
            :total="total"
            layout="total,prev, pager, next"
            style="text-align: left; margin: 20px 0"
            @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </CommonLayout>
    <el-dialog
        :close-on-click-modal="false"
        :title="Title"
        :visible.sync="dialogFormVisible"
        @closed="isSubmit = true"
    >
      <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="demo-ruleForm"
          label-width="100px"
      >
        <div class="form-title">基本信息</div>

        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item label="成果名称" prop="name">
                <el-input
                    v-model="form.name"
                    clearable
                    placeholder="请输入成果名称"
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="行业分类" prop="tradeCate">
                <el-select
                    v-model="form.tradeCate"
                    clearable
                    placeholder="请选择"
                    style="width: 100%"
                >
                  <el-option
                      v-for="(item, index) in checkList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="应用范围" prop="applyRange">
                <el-input
                    v-model="form.applyRange"
                    clearable
                    placeholder="请填写应用范围"
                    type="textarea"
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="专利状态" prop="patentStatus">
                <el-input
                    v-model="form.patentStatus"
                    clearable
                    placeholder="请填写技术状态"
                    type="textarea"
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="技术状态" prop="techStatus">
                <el-select
                    v-model="form.techStatus"
                    clearable
                    placeholder="请选择"
                    style="width: 100%"
                >
                  <el-option
                      v-for="(item, index) in options.stage"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="合作方式" prop="cooperateMode">
                <el-input
                    v-model="form.cooperateMode"
                    clearable
                    placeholder="请填写合作方式"
                    type="textarea"
                ></el-input>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="封面图片"
                prop="image"
                style="text-align: right"
            >
              <el-upload
                  :action="this.uploadURL"
                  :before-upload="beforeAvatarUpload"
                  :http-request="HouImgFile"
                  :on-success="handlePictureCardPreview"
                  :show-file-list="false"
                  class="avatar-uploader"
                  name="file"
              >
                <img
                    v-if="form.image"
                    :src="imgUrl + form.image"
                    class="img_border"
                />
                <i
                    v-else
                    :class="{ is_border: !form.image }"
                    class="el-icon-plus avatar-uploader-icon"
                ></i>
                <span v-if="!form.image" class="upload_btn">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span v-show="form.image" class="del_img">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="技术先进度" prop="techAdvanced">
              <el-select
                  v-model="form.techAdvanced"
                  clearable
                  placeholder="请选择"
                  style="width: 100%"
              >
                <el-option
                    v-for="(item, index) in options.stage1"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布时间" prop="publishDateTime">
              <el-date-picker
                  v-model="form.publishDateTime"
                  :picker-options="pickerOptions"
                  format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="width: 100%"
                  type="date"
                  value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-title">项目来源</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactName">
              <el-input
                  v-model="form.contactName"
                  clearable
                  placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                  v-model="form.contactPhone"
                  clearable
                  placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="通信地址" prop="detailed">
            <v-distpicker
                :area="form.address.area.value"
                :city="form.address.city.value"
                :province="form.address.province.value"
                style="text-align: left"
                @selected="citySelected"
            ></v-distpicker>
            <el-input
                v-model="form.detailed"
                placeholder="请填写详细地址"
                style="margin-top: 10px"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位名称" prop="companyName">
              <el-input
                  v-model="form.companyName"
                  clearable
                  placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交易金额" prop="tradeAmount">
              <el-input
                  v-model="form.tradeAmount"
                  clearable
                  placeholder="请输入交易金"
              >
                <template slot="append">万</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-title">项目简介</div>
        <el-row>
          <el-form-item label="成果简介" prop="content">
            <editor
                v-model="form.content"
                :img-show-url="imgUrl"
                :upload-url="uploadURL"
            ></editor>
          </el-form-item>
          <el-col>
            <el-form-item label="预期效益" prop="income">
              <editor
                  v-model="form.income"
                  :img-show-url="imgUrl"
                  :upload-url="uploadURL"
              ></editor>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="flex-end">
            <el-button type="primary" @click="getTopKey"
            >点击获取关键词
            </el-button
            >
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="12">
            <el-row>
              <el-form-item
                  label="审核人"
                  prop="checkerId"
                  style="text-align: left"
              >
                <el-select v-model="form.checkerId" placeholder="请选择" style="width:100%" @change="changeCheck()">
                  <el-option
                      v-for="(item, index) in checkerOption"
                      :key="index"
                      :label="item.username"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item
                  label="审核状态"
                  prop="examineStatus"
                  style="text-align: left"
              >
                <el-select v-model="form.examineStatus" :disabled="!isCheck || !isChecker" placeholder="请选择"
                           style="width:100%">
                  <el-option
                      v-for="(item, index) in showOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-form-item label="关键字" prop="keywords">
              <el-select
                  v-model="form.keywords"
                  allow-create
                  default-first-option
                  filterable
                  multiple
                  placeholder="请选择文章标签"
                  style="width: 100%"
                  @change="changeKeyWords"
              >
                <el-option
                    v-for="(item, index) in ResourceKeys"
                    :key="index"
                    :label="item.key"
                    :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-button type="primary" @click="submitForm('form')"
            >提交
            </el-button
            >
            <el-button @click="closeForm('form')">取消</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import CommonLayout from "../../components/common-layout.vue";
import editor from "../../components/tinymce-editor/tinymce-editor";
import {DisabledDateFn} from "@/utils/tool";
import {getToken} from "@/utils/auth";
import {download1} from "@/utils/download";
// import editor from "../../components/yhQuillEditor";
export default {
  components: {
    editor,
    CommonLayout,
  },
  data() {
    return {
      isCheck: false,
      isChecker: false,
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      isSubmit: true,
      times: "",
      visible: false,
      // value:'',
      fieldValue: "",
      progressValue: "",
      jishuValue: "",
      tradeValue: "",
      naturalValue: "",
      typeValue: "",
      wayValue: "",
      deleteRow: "",
      total: 10,
      per_page: 10,
      current_page: 1,
      checkAll: false,
      isIndeterminate: false,
      image: "",
      searchValue: "",
      dialogFormVisible: false,
      Title: "新增",
      tableData: [],
      ResourceKeys: [],
      form: {
        companyName: "",
        name: "",
        patentStatus: "",
        income: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "", /////详细的地址
        applyRange: "", //////应用范围
        tradeCate: "", /////行业分类
        originAchieveFirst: "",
        originAchieveSecond: "",
        originAchieveThird: "",
        cooperateMode: "",
        techStatus: "",
        techAdvanced: "",
        publishDateTime: "",
        contactName: "",
        contactPhone: "",
        content: "",
        examineStatus: 2,
        achievementsOrigin: [],
        keywords: [],
        checkerId: "",
      },
      showOptions: [
        {
          value: 3,
          label: "待审核",
        },
        {
          value: 1,
          label: "通过",
        },
        {
          value: 2,
          label: "未通过",
        },
      ],
      options: {
        stage: [
          {
            value: "001",
            label: "小批量生产",
          },
          {
            value: "002",
            label: "工程应用阶段/批量生产",
          },
          {
            value: "003",
            label: "成熟应用阶段",
          },
        ],
        stage1: [
          {
            value: "001",
            label: "国际领先",
          },
          {
            value: "002",
            label: "国际先进",
          },
          {
            value: "003",
            label: "国内领先",
          },
          {
            value: "004",
            label: "国内先进",
          },
        ],
        source1: [
          {
            value: "001",
            label: "民营企业",
          },
          {
            value: "002",
            label: "国有企业",
          },
          {
            value: "003",
            label: "其他",
          },
        ],
        source: [
          {
            value: "001",
            label: "技术转移中心",
            children: [
              {
                value: "0011",
                label: "张江兰白创新改革试验区技术转移中心",
              },
              {
                value: "0012",
                label: "北京大学技术转移甘肃中心",
              },
              {
                value: "0013",
                label: "中国科学技术大学技术转移甘肃中心",
              },
              {
                value: "0014",
                label: "国家技术转移东部中心",
              },
              {
                value: "0015",
                label: "瑞士洛桑大学技术转移中心",
              },
              {
                value: "0016",
                label: "新加坡南洋理工大学技术转移中心",
              },
            ],
          },
          {
            value: "002",
            label: "一院三所",
            children: [
              {
                value: "0021",
                label: "中国科学院兰州化学物理研究所",
              },
              {
                value: "0022",
                label: "中国科学院近代物理研究所",
              },
              {
                value: "0023",
                label: "中国科学院寒区旱区环境与工程研究所",
              },
            ],
          },
          {
            value: "003",
            label: "在甘院校",
            children: [
              {
                value: "0031",
                label: "高等院校",
                children: [
                  {
                    value: "00311",
                    label: "兰州大学",
                  },
                  {
                    value: "00312",
                    label: "兰州理工大学",
                  },
                  {
                    value: "00313",
                    label: "兰州交通大学",
                  },
                  {
                    value: "00314",
                    label: "西北民族大学",
                  },
                  {
                    value: "00315",
                    label: "甘肃农业大学",
                  },
                  {
                    value: "00316",
                    label: "兰州城市学院",
                  },
                  {
                    value: "00317",
                    label: "西北师范大学",
                  },
                  {
                    value: "00318",
                    label: "河西学院",
                  },
                  {
                    value: "00319",
                    label: "陇东学院",
                  },
                ],
              },
              {
                value: "0032",
                label: "科研院所",
                children: [
                  {
                    value: "00321",
                    label: "甘肃省科学院",
                  },
                  {
                    value: "00322",
                    label: "甘肃省农业科学院",
                  },
                  {
                    value: "00323",
                    label: "甘肃省膜科学技术研究院有限公司",
                  },
                  {
                    value: "00324",
                    label: "甘肃省科学院生物研究所",
                  },
                  {
                    value: "00325",
                    label: "甘肃省商业科技研究所",
                  },
                  {
                    value: "00326",
                    label: "甘肃省建材科研设计院",
                  },
                ],
              },
            ],
          },
          {
            value: "004",
            label: "省属企业",
          },
          {
            value: "005",
            label: "省外合作机构",
          },
          {
            value: "006",
            label: "新型研发机构",
            children: [
              {
                value: "0061",
                label: "兰州大学白银产业技术研究院",
              },
              {
                value: "0062",
                label: "兰州理工大学白银新材料研究院",
              },
              {
                value: "0063",
                label: "甘肃西部凹凸棒石应用研究院",
              },
              {
                value: "0064",
                label: "白银市东西部协同创新研究院",
              },
              {
                value: "0065",
                label: "甘肃省陇杞中药研究院",
              },
              {
                value: "0066",
                label: "白银市实创高新产业研究院",
              },
            ],
          },
          {
            value: "007",
            label: "其他",
          },
        ],
        type: [
          {
            value: "001",
            label: "技术开发",
          },
          {
            value: "002",
            label: "技术转让",
          },
          {
            value: "003",
            label: "技术咨询",
          },
          {
            value: "004",
            label: "技术服务",
          },
        ],
        cooperation: [
          {
            value: "001",
            label: "委托开发",
          },
          {
            value: "002",
            label: "许可转让",
          },
          {
            value: "003",
            label: "完全转让",
          },
          {
            value: "004",
            label: "技术入股",
          },
          {
            value: "005",
            label: "技术许可",
          },
          {
            value: "006",
            label: "合作转化",
          },
          // {
          //   value: "007",
          //   label: "自我转化"
          // },
          {
            value: "008",
            label: "其他",
          },
        ],
      },
      checkList: [
        {
          id: "001",
          name: "装备制造",
        },
        {
          id: "002",
          name: "材料",
        },
        {
          id: "003",
          name: "能源",
        },
        {
          id: "004",
          name: "环境保护",
        },
        {
          id: "005",
          name: "海洋工程",
        },
        {
          id: "006",
          name: "航空航天",
        },
        {
          id: "007",
          name: "电子信息",
        },
        {
          id: "008",
          name: "其他",
        },
      ],
      typeOptions: [
        {
          value: "001",
          label: "农业与化工",
        },
        {
          value: "002",
          label: "生物与医药",
        },
        {
          value: "003",
          label: "能源与采矿",
        },
        {
          value: "004",
          label: "建筑与水利",
        },
        {
          value: "005",
          label: "交通与运输",
        },
        {
          value: "006",
          label: "自然与社科",
        },
      ],
      rules: {
        name: [{required: true, message: "请输入成果名称", trigger: "blur"}],
        detailed: [
          {
            validator: (rule, value, callback) =>
                this.CheckAddress(rule, value, callback, this.form),
            required: true,
            trigger: "blur",
          },
        ],
        patentStatus: [
          {required: true, message: "请输入专利状态", trigger: "blur"},
        ],
        applyRange: [
          {required: true, message: "请输入应用范围", trigger: "change"},
        ],
        tradeCate: [
          {required: true, message: "请选择行业分类", trigger: "change"},
        ],
        companyName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur",
          },
        ],
        cooperateMode: [
          {required: true, message: "请输入合作方式", trigger: "change"},
        ],
        techStatus: [
          {required: true, message: "请选择技术状态", trigger: "change"},
        ],
        techAdvanced: [
          {required: true, message: "请选择技术先进度", trigger: "change"},
        ],
        publishDateTime: [
          {required: true, message: "请选择发布时间", trigger: "change"},
        ],
        contactName: [
          {required: true, message: "请输入联系人", trigger: "blur"},
        ],

        contactPhone: [
          {required: true, message: "请输入联系电话", trigger: "blur"},
        ],
        keywords: [
          {required: true, message: "请选择关键字", trigger: "blur"},
        ],
        content: [
          {required: true, message: "请输入科技成果简介", trigger: "blur"},
        ],
      },
      checkerOption: [],
    };
  },
  created() {
    this.getCheck();
    //this.getTree();
    this.getData(`${urlConfig.devUrl}apij2/admin-api/trade/tech-achieve/page`, {page: this.current_page});
    this.getKey();
  },
  methods: {
    //审核人
    getCheck() {
      this.http
          .post(`${urlConfig.devUrl}apij2/admin-api/system/user/page`, {type: 2, isChecker: 1, checkerModuleId: 5})
          .then((res) => {
            if (res.code === 0) {
              this.checkerOption = res.data.data;
            }
          });
    },
    changeCheck() {
      this.isChecker = this.form.checkerId == getToken() ? true : false;
      this.isCheck = this.form.checkerId ? true : false;
    },
    // 监听关键词变更
    changeKeyWords(val) {
      if (val.length > 5) {
        this.$message.warning("最多5个关键词");
        this.form.keywords = val.slice(0, 5);
      }
    },
    // 获取关键词

    async getTopKey() {
      let str = this.GetTarg(this.form?.content);
      let data = await this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-key/automaticRetrieval`, {content: str});
      this.form.keywords = data.data.map((el) => el.key);
    },
    getTree() {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/user-bind-unit/getListAndTree`, {}).then((res) => {
        if (res.code === 0) {
          this.options.source = res.data.data.tree;
        }
      });
    },
    //导出
    exportOut() {
      let url = "";
      if (this.times) {
        url =
            `${urlConfig.devUrl}apij2/admin-api/trade/tech-achieve/export-excel?startTime=` +
            this.times[0] +
            "&endTime=" +
            this.times[1];
      } else {
        url = `${urlConfig.devUrl}apij2/admin-api/trade/tech-achieve/export-excel`;
      }
      download1(url, '军民融合-科技成果.xls');
    },
    getKey() {
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/resource-key/listAll`).then((res) => {
        if (res.code === 0) {
          this.ResourceKeys = res.data;
        }
      });
    },
    getData(url, data) {
      this.http.post(url, data).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
          this.current_page = res.data.current_page * 1;
        }
      });
    },
    //新增
    addAch() {
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      this.isCheck = false;
      this.isChecker = false;
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.form = {
        name: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        applyRange: "",
        tradeCate: "",
        achievementsOrigin: [],
        originAchieveFirst: "",
        originAchieveSecond: "",
        originAchieveThird: "",
        cooperateMode: "",
        techStatus: "",
        techAdvanced: "",
        publishDateTime: "",
        contactName: "",
        contactPhone: "",
        content: "",
        examineStatus: 2,
        keywords: "",
        checkerId: "",
      };
    },
    //编辑
    handleEdit(index, row) {
      this.isCheck = row.checkerId ? true : false;
      this.isChecker = row.checkerId == getToken() ? true : false;
      this.form.achievements_origin = [];
      this.dialogFormVisible = true;
      this.Title = "编辑";
      this.form.name = row.name;
      this.form.image = row.image;
      this.form = JSON.parse(JSON.stringify(row));
      this.form.address = JSON.parse(row.address);
      this.form.detailed = this.form.address.detailed;
      this.form.achievementsOrigin = this.form.achievementsOrigin
          ? JSON.parse(this.form.achievementsOrigin)
          : this.form.achievementsOrigin;
      this.form.examineStatus = Number(this.form.examineStatus);
      this.form.keywords = row.keywords ? row.keywords.split(",") : [];
      this.form.checkerId = row.checkerId ? row.checkerId : "";
    },
    //翻页
    handleCurrentChange(e) {
      this.getData(
          `${urlConfig.devUrl}apij2/admin-api/trade/tech-achieve/page`,
          {
            keyword: this.searchValue,
            page: e,
            tradeCate: this.fieldValue,
            techStatus: this.jishuValue,
            techAdvanced: this.progressValue
          }
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length !== 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
          .then(() => {
            this.http
                .delete(`${urlConfig.devUrl}apij2/admin-api/trade/tech-achieve/delete?id=${row.id}`)
                .then((res) => {
                  if (res.code === 0) {
                    this.search();
                    this.$message({
                      type: "success",
                      message: "删除成功",
                    });
                    this.ResetSearch([
                      "searchValue",
                      "fieldValue",
                      "jishuValue",
                      "progressValue",
                    ]);
                  } else {
                    this.$message({
                      message: "失败！",
                      type: "error",
                    });
                  }
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
            .then(() => {
              this.http
                  .delete(`${urlConfig.devUrl}apij2/admin-api/trade/tech-achieve/deleteAll?ids=${this.deleteRow}`)
                  .then((res) => {
                    if (res.code === 0) {
                      this.search();
                      this.$message({
                        type: "success",
                        message: "删除成功",
                      });
                      this.ResetSearch([
                        "searchValue",
                        "fieldValue",
                        "jishuValue",
                        "progressValue",
                      ]);
                    } else {
                      this.$message({
                        message: "失败！",
                        type: "error",
                      });
                    }
                  });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的记录",
        });
      }
    },
    //获取经纬度
    factory(name) {
      // this.subData(name)
      this.$jsonp(
          "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          this.form.detailed +
          "&city=" +
          this.form.address.city.value +
          "&children=1&offset=20&page=1&extensions=all"
      )
          .then((json) => {
            let arr = json.pois[0].location.split(",");
            this.form.lng = arr[0];
            this.form.lat = arr[1];
            this.subData(name);
          })
          .catch((err) => {
            this.$message.error("未获取到经纬度,请查看地址是否完整");
            this.isSubmit = true;
          });
    },
    subData(name) {
      let obj = JSON.parse(JSON.stringify(this.form));
      let arr = [];
      obj.address.detailed = this.form.detailed;
      let area = [
        {
          name: "兰州市",
          id: "001",
        },
        {
          name: "嘉峪关市",
          id: "002",
        },
        {
          name: "金昌市",
          id: "003",
        },
        {
          name: "白银市",
          id: "004",
        },
        {
          name: "天水市",
          id: "005",
        },
        {
          name: "武威市",
          id: "006",
        },
        {
          name: "张掖市",
          id: "007",
        },
        {
          name: "酒泉市",
          id: "008",
        },
        {
          name: "平凉市",
          id: "009",
        },
        {
          name: "庆阳市",
          id: "010",
        },
        {
          name: "定西市",
          id: "011",
        },
        {
          name: "陇南市",
          id: "012",
        },
        {
          name: "临夏回族自治州",
          id: "013",
        },
        {
          name: "甘南藏族自治州",
          id: "014",
        },
      ];
      area.forEach((item) => {
        if (obj.address.city.value === item.name) {
          obj.area = item.id;
        }
      });
      let array = [],
          array1 = [],
          array2 = [];
      if (obj.achievementsOrigin.length) {
        array.push(obj.achievementsOrigin[0]);
        obj.achievementsOrigin[1]
            ? array1.push(obj.achievementsOrigin[1])
            : "";
        obj.achievementsOrigin[2]
            ? array2.push(obj.achievementsOrigin[2])
            : "";
      }
      obj.originAchieveFirst = this.unique(array).join(",");
      // obj.achievementsOrigin = this.unique(array).join(",");
      obj.originAchieveSecond = this.unique(array1).join(",");
      obj.originAchieveThird = this.unique(array2).join(",");
      // obj.natural_json = JSON.stringify(obj.naturalArr);
      obj.achievementsOrigin = JSON.stringify(obj.achievementsOrigin);
      if (!obj.originAchieveSecond) {
        delete obj.originAchieveSecond;
      }
      if (!obj.originAchieveThird) {
        delete obj.originAchieveThird;
      }
      if (!obj.originAchieveSecond) {
        delete obj.originAchieveSecond;
      }
      if (!obj.originAchieveFirst) {
        delete obj.originAchieveFirst;
      }

      obj.address = JSON.stringify(obj.address);
      obj.keywords = obj.keywords.join(",");
      obj.image = obj?.image || "";
      if (!this.form.id) {
        obj.examineStatus = 3
        this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/trade/tech-achieve/create`, obj)
            .then((res) => {
              if (res.code === 0) {
                this.search();
                this.getKey();
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
                this.dialogFormVisible = false;
                this.$refs[name].resetFields();
                this.ResetSearch([
                  "searchValue",
                  "fieldValue",
                  "jishuValue",
                  "progressValue",
                ]);
              } else {
                this.isSubmit = true;
              }
            })
            .catch((err) => {
              this.isSubmit = true;
            });
      } else {
        this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/trade/tech-achieve/update`, obj)
            .then((res) => {
              if (res.code === 0) {
                this.search();
                this.getKey();
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
                this.ResetSearch([
                  "searchValue",
                  "fieldValue",
                  "jishuValue",
                  "progressValue",
                ]);

                this.dialogFormVisible = false;
                this.$refs[name].resetFields();
              } else {
                this.isSubmit = true;
              }
            })
            .catch((err) => {
              this.isSubmit = true;
            });
      }
    },

    // 禁用今日以后时间
    disabledDateFn(date) {
      let flag = DisabledDateFn(date);
      return flag;
    },
    //提交
    submitForm(name) {
      if (!this.isSubmit) return false;
      this.isSubmit = false;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.factory(name);
        } else {
          this.isSubmit = true;

          return false;
        }
      });
    },
    //数组去重
    unique(arr) {
      return arr.filter((ele, index, array) => {
        return array.indexOf(ele) === index;
      });
    },
    //关闭
    closeForm(name) {
      this.$refs[name].resetFields();
      this.dialogFormVisible = false;
    },
    //查找
    search() {
      this.getData(
          `${urlConfig.devUrl}apij2/admin-api/trade/tech-achieve/page`,
          {
            keyword: this.searchValue,
            page: 1,
            tradeCate: this.fieldValue,
            techStatus: this.jishuValue,
            techAdvanced: this.progressValue
          }
      );
    },
    //审核
    release(row, type) {
      let obj = {
        examineStatus: type,
      };
      this.$jsonp(
          "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          row.address.detailed +
          "&city=" +
          row.address.city.value +
          "&children=1&offset=20&page=1&extensions=all"
      )
          .then((json) => {
            let arr = json.pois[0].location.split(",");
            obj.lng = arr[0];
            obj.lat = arr[1];
            this.http.put("tech_achieve/" + row.id, obj).then((res) => {
              if (res.code == 0) {
                if (type == 1) {
                  this.$message.success("审核通过");
                } else {
                  this.$message.success("审核不通过");
                }
                this.search();
              }
            });
          })
          .catch((err) => {
            this.isSubmit = true;

            this.$message.error("未获取到经纬度,请查看地址是否完整");
          });
    },
    //富文本
    // getQuillData(val) {
    //   this.form.content = val;
    // },
    //城市选择
    citySelected(e) {
      this.form.address = e;
    },
    //关注领域
    // handleCheckAllChange(val) {
    //   this.form.checked = val ? this.checkList : [];
    //   this.isIndeterminate = false;
    // },
    // handleCheckedCitiesChange(value) {
    //   let checkedCount = value.length;
    //   this.checkAll = checkedCount === this.checkList.length;
    //   this.isIndeterminate =
    //     checkedCount > 0 && checkedCount < this.checkList.length;
    // },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {width: 960})
          .then((rst) => {
            this.http
                .post("/file/base64_upload", {image: rst.base64})
                .then((res) => {
                  this.form.image = res.data;
                });
            return rst;
          })
          .always(() => {
            // 清空文件上传控件的值
            e.target.value = null;
          });
    },

    handlePictureCardPreview(file) {
      this.form.image = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
          file.type === "image/jpeg" ||
          file.type === "image/png" ||
          file.type === "image/jpg" ||
          file.type === "image/gif" ||
          file.type === "image/bmp"
      ) {
        type = true;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
          .then(() => {
            this.form.image = "";
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.achievement {
  width: 100%;
  height: 100%;

  .achievement-search {
    width: 100%;
    text-align: left;
    // margin-top: 20px;
    .el-select {
      margin: 0 15px;

      .el-input {
        margin: 0;
      }
    }

    .el-cascader {
      margin: 0 15px;

      .el-input {
        margin: 0;
      }
    }

    .el-input {
      margin: 0 15px;
    }
  }

  .achievement-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }

  .form-title {
    width: 100%;
    text-align: left;
    color: #0572a4;
    border-left: 5px solid #0572a4;
    border-bottom: 1px solid #0572a4;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }

  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
